import { Center, Alert } from '@chakra-ui/react';

export function LocationError({ message }: { message: string }) {
  return (
    <Center w="full">
      <Alert status="error" role="alert">
        {message || 'An error occurred'}
      </Alert>
    </Center>
  );
}
